import { clamp } from "./canvasMath";
import type { PointerKind } from "./canvasTypes";

export const DEFAULT_PRESSURE = 0.65;
export const MIN_PRESSURE = 0.12;

export function normalizePressure(
  rawPressure: number,
  pointerType: PointerKind,
  pressureEnabled: boolean,
): number {
  if (!pressureEnabled || pointerType !== "pen") return DEFAULT_PRESSURE;
  if (!Number.isFinite(rawPressure) || rawPressure <= 0) return DEFAULT_PRESSURE;
  return clamp(rawPressure, MIN_PRESSURE, 1);
}

export function smoothPressure(previous: number, next: number, response = 0.35): number {
  const safePrevious = clamp(previous, MIN_PRESSURE, 1);
  const safeNext = clamp(next, MIN_PRESSURE, 1);
  const weight = clamp(response, 0, 1);
  return safePrevious + (safeNext - safePrevious) * weight;
}

export function pressureToWidthFactor(pressure: number): number {
  return 0.45 + clamp(pressure, MIN_PRESSURE, 1) * 0.9;
}
